import { cdiService } from '../services'

export default (clientId) => {
  return new Promise((resolve, reject) => {
    cdiService.getParamsUboFinder(clientId)
      .then(response => resolve(response))
      .catch(err => reject({ error: true }))
  })
}
